"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteValueToInteractableToken = void 0;
var _blendColors = require("../color/blendColors");
var _interactable = require("../tokens/interactable");
var _memoize = require("../utils/memoize");
var _paletteValueToCacheName = require("./paletteValueToCacheName");
var _paletteValueToHueStep = require("./paletteValueToHueStep");
var _paletteValueToRgbaArray = require("./paletteValueToRgbaArray");
var _paletteValueToTuple4 = require("./paletteValueToTuple");
const mobileTransparentTokens = {
  disabled: {
    contentOpacity: _interactable.accessibleOpacityDisabled,
    backgroundColor: 'transparent'
  },
  hovered: undefined,
  pressed: {
    contentOpacity: _interactable.opacityPressed[100],
    backgroundColor: 'transparent'
  }
};
const webTransparentTokens = Object.assign({}, mobileTransparentTokens, {
  hovered: {
    contentOpacity: _interactable.opacityHovered[100],
    backgroundColor: 'transparent'
  }
});
function getCacheKey({
  paletteValue,
  options: {
    paletteConfig,
    spectrum,
    isWeb
  }
}) {
  const background = paletteConfig.background,
    foreground = paletteConfig.foreground;
  const _paletteValueToTuple = (0, _paletteValueToTuple4.paletteValueToTuple)(background),
    backgroundAlias = _paletteValueToTuple[0],
    backgroundOpacity = _paletteValueToTuple[1];
  const _paletteValueToTuple2 = (0, _paletteValueToTuple4.paletteValueToTuple)(foreground),
    foregroundAlias = _paletteValueToTuple2[0],
    foregroundOpacity = _paletteValueToTuple2[1];
  return `${(0, _paletteValueToCacheName.paletteValueToCacheName)(paletteValue, spectrum)}-background-${backgroundAlias}-${backgroundOpacity}-foreground-${foregroundAlias}-${foregroundOpacity}-isWeb-${isWeb}`;
}
const paletteValueToInteractableToken = (0, _memoize.memoize)(({
  paletteValue,
  options: {
    paletteConfig,
    spectrum,
    isWeb
  }
}) => {
  const background = paletteConfig.background,
    foreground = paletteConfig.foreground;
  const _paletteValueToTuple3 = (0, _paletteValueToTuple4.paletteValueToTuple)(paletteValue),
    overlayAlias = _paletteValueToTuple3[0],
    overlayOpacity = _paletteValueToTuple3[1];

  // For interables with opacity zero we do not need to do any underlay/overlay blending.
  if (overlayOpacity === 0) {
    return isWeb ? webTransparentTokens : mobileTransparentTokens;
  }
  const hueStep = (0, _paletteValueToHueStep.paletteValueToHueStep)(paletteValue);
  const underlayAlias = hueStep > 60 ? 'background' : 'foreground';
  const backgroundRgbaArray = (0, _paletteValueToRgbaArray.paletteValueToRgbaArray)(background, spectrum);
  const foregroundRgbaArray = underlayAlias === 'background' ? backgroundRgbaArray : (0, _paletteValueToRgbaArray.paletteValueToRgbaArray)(foreground, spectrum);
  const opacity = {
    disabled: _interactable.accessibleOpacityDisabled,
    pressed: _interactable.opacityPressed[hueStep],
    hovered: _interactable.opacityHovered[hueStep]
  };
  const overlay = {
    disabled: (0, _paletteValueToRgbaArray.paletteValueToRgbaArray)([overlayAlias, _interactable.accessibleOpacityDisabled], spectrum),
    pressed: (0, _paletteValueToRgbaArray.paletteValueToRgbaArray)([overlayAlias, opacity.pressed], spectrum),
    hovered: (0, _paletteValueToRgbaArray.paletteValueToRgbaArray)([overlayAlias, opacity.hovered], spectrum)
  };
  const underlay = {
    disabled: backgroundRgbaArray,
    pressed: foregroundRgbaArray,
    hovered: foregroundRgbaArray
  };
  return {
    disabled: {
      contentOpacity: opacity.disabled,
      backgroundColor: (0, _blendColors.blendColors)({
        underlayColor: underlay.disabled,
        overlayColor: overlay.disabled
      })
    },
    pressed: {
      contentOpacity: opacity.pressed,
      backgroundColor: (0, _blendColors.blendColors)({
        underlayColor: underlay.pressed,
        overlayColor: overlay.pressed
      })
    },
    hovered: isWeb ? {
      contentOpacity: opacity.hovered,
      backgroundColor: (0, _blendColors.blendColors)({
        underlayColor: underlay.hovered,
        overlayColor: overlay.hovered
      })
    } : undefined
  };
}, getCacheKey);
exports.paletteValueToInteractableToken = paletteValueToInteractableToken;